import type { FC } from "react";
import {
  Avatar,
  Badge,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import { useTranslation } from "@/shared/hooks";

interface OnlineMember {
  id: string;
  userDisplayName?: string | null;
  userAvatar?: { url?: string | null } | null;
  isOnline: boolean;
}

interface ChatOnlineListProps {
  open: boolean;
  onClose: () => void;
  members: OnlineMember[];
}

export const ChatOnlineList: FC<ChatOnlineListProps> = ({
  open,
  onClose,
  members,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t("stream.chat.online.title")}</DialogTitle>
      <List>
        {members.map((member) => (
          <ListItem key={member.id}>
            <ListItemAvatar>
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                variant="dot"
                color={member.isOnline ? "success" : "default"}
              >
                <Avatar src={member.userAvatar?.url ?? undefined} />
              </Badge>
            </ListItemAvatar>
            <ListItemText primary={member.userDisplayName} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
};
